export interface IHealthCheckItem {
  key: string
  label: string
}

// 従業員健康チェック表（HACCP）のチェック項目
export const HEALTH_CHECK_ITEMS: IHealthCheckItem[] = [
  { key: 'item0', label: '発熱' },
  { key: 'item1', label: '下痢' },
  { key: 'item2', label: '嘔吐・吐き気' },
  { key: 'item3', label: '腹痛' },
  { key: 'item4', label: '発熱を伴う喉の痛み' },
  { key: 'item5', label: '黄疸' },
  { key: 'item6', label: '耳・目・鼻の異常な分泌物' },
  { key: 'item7', label: '手指・腕等の化膿した傷' },
  { key: 'item8', label: 'その他の体調不良' },
  { key: 'item9', label: '手指・身だしなみ' },
]
